// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"96":"9da2cfd9","215":"300efcea","417":"cae3bc21","506":"f26272e7","852":"8317d448","874":"ff064a3b"}[chunkId] + ".chunk.css";
};